import React, { useContext, useEffect } from 'react';
import { Link, navigate, useLocation } from '@reach/router';
import { Store } from './data/Store';
import { elasticSearch, updateLocalView, cloneRemoteData, createRemoteData, updateRemoteData, deleteRemoteData, clearLocalData } from './data/Actions';
import WebHeader from './components/WebHeader';

import styled from 'styled-components';

import { Modal, Button } from 'antd';
import 'antd/dist/antd.css';
import {
    FormOutlined,
    CopyOutlined,
    DeleteOutlined,
    LeftOutlined
}
from '@ant-design/icons';

const Footer = styled.footer `
    background-color: var(--bp-list-head-foot) !important;
`;
const Layout = styled.div `
    height: 100vh;
    display: grid;
    grid-template: 140px 1fr 50px / 100%;
`;
const Content = styled.div `
    overflow: scroll;
`;
const ButtonBox = styled.div `
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    padding-right: 10px;
`;
const StyledButton = styled(Button)`
    background-color: var(--bp-control) !important;
    border: none;
    font-weight: bold;
    &:hover {
        background-color: var(--bp-control) !important;
    }
    &:active {
        background-color: var(--bp-control) !important;
    }
`;

function FooterNav(props) {
    const { state, dispatch } = useContext(Store);

    async function newPedigree(type) {
        let newPedigree = await createRemoteData(type, state, dispatch);
    }
    async function savePedigree(e) {
        let ItemId = state.Pedigree.Transaction.ItemId.value;
        let LotId = state.Pedigree.Transaction.LotId.value;
        
        if (state.PedType === 'TEMP') {
            if (ItemId === '' || LotId === '') {
                Modal.warning({
                    title: 'You must enter an "Item Number" and "Lot ID"',
                    content: '',
                });
            } else {
                const isTemplate = await testTemplateExistes(ItemId, LotId);
                if (isTemplate) {
                    let savePedigree = await updateRemoteData(state, dispatch);
                    updateLocalView({PedType: 'TEMP'}, state, dispatch);
                    navigate(`${process.env.PUBLIC_URL}/template`);
                } else {
                    Modal.warning({
                        title: '"Item Number" and "Lot ID" must be unique',
                        content: 'A template with this Item Number and Lot ID already exists',
                    });
                }
            }
        } else {
            // let clientId = state.Pedigree.ClientId.value;
            // let trimString = clientId.trim();
            
            // if (hasWhiteSpace(trimString)) {
            //     Modal.warning({
            //         title: '"Client Id" can not contain spaces',
            //         content: '',
            //     });
            // } else {
            //     let savePedigree = await updateRemoteData(state, dispatch);
            //     updateLocalView({PedType: 'USER'}, state, dispatch);
            //     navigate(`${process.env.PUBLIC_URL}/`);
            // }
            
            let savePedigree = await updateRemoteData(state, dispatch);
                updateLocalView({PedType: 'USER'}, state, dispatch);
                setTimeout(function(){ navigate(`${process.env.PUBLIC_URL}/`); }, 1000);
                
        }
        
        function hasWhiteSpace(s) {
          return /\s/g.test(s);
        }
        
        async function testTemplateExistes(ItemId, LotId) {
            const searchData = [
                {key:'Pedigree.Transaction.ItemId', value: ItemId},
                {key:'Pedigree.Transaction.LotId', value: LotId}
            ];
  
            const data = {
                search: searchData,
                limit: 1,
                pedType: 'TEMP'
            };
            
            let tempCheck = await elasticSearch(data, state, dispatch);
            
            
            if (
                tempCheck.hasOwnProperty('data')
                && tempCheck.data.hasOwnProperty('searchTransaction')
                && tempCheck.data.searchTransaction.hasOwnProperty('items')
                ) {
                const itemsArr = tempCheck.data.searchTransaction.items;

                if (itemsArr.length === 0) return true;
                else if (isUpdateTemplate(itemsArr)) return true;
                else return false;
                
            } else {
                console.log('Template exists test failed');
            }
            
            function isUpdateTemplate(itemsArr) {
                if (itemsArr.length === 1) {
                    return (itemsArr[0].id === state.Pedigree.id.value);
                } else {
                    return false;
                }
            }
        }
    }
    
    function deletePedigree(e) {
        let deletePedigree = deleteRemoteData(state, dispatch);
    }
    async function addProduct() {
        let savePedigree = await updateRemoteData(state, dispatch);
        let clonePedigree = await cloneRemoteData(state, dispatch);

        navigate(`${process.env.PUBLIC_URL}/pedigree/${clonePedigree.id}`);
    }

    return (props.path === `${process.env.PUBLIC_URL}/`
            || props.path === `${process.env.PUBLIC_URL}/template`) ? (
        (state.User === 'USER') ? ('') : (
            state.PedType === 'USER' ? (
                <ButtonBox>
                    <StyledButton type="primary" onClick={()=>newPedigree('USER')}>+ New Pedigree</StyledButton>
                </ButtonBox>
            ) : (
                <ButtonBox>
                    <StyledButton type="primary" onClick={()=>newPedigree('TEMP')}>+ New Template</StyledButton>
                </ButtonBox>
            )
        )
    ) : (
        (props.path !== `${process.env.PUBLIC_URL}/admin`) ?
            <ButtonBox>
                <StyledButton type="primary" onClick={savePedigree}><LeftOutlined /> Save</StyledButton>
            </ButtonBox>
            : <span></span>
    );
}

function App(props) {
    
    useEffect(() => {
        navigate(`${window.location.pathname}`);
    }, []);
  
    const { state, dispatch } = useContext(Store);
    const locationPath = useLocation();
    
    state.User = props.user;
    return (
        <Layout>
            <header>
                <WebHeader path={locationPath} signout={props.signout}></WebHeader>
            </header>
            <Content>
                {props.children}
            </Content>
            <Footer>
                <FooterNav path={props.location.pathname} pedigree={props.pedigree}/>
            </Footer>
        </Layout>
    );
}
export default App;
